export const LOGIN_COMMANDS_PREFIX = "whatslly-full-screen-widget"; // this prefix is used in old commands, just for the sake of backward compatibility

export const LoginCommands = {
  ABORT_TRANSACTION: `${LOGIN_COMMANDS_PREFIX}:abort-transaction`,
  RESPONSE: `${LOGIN_COMMANDS_PREFIX}:response`,
  ERROR: `${LOGIN_COMMANDS_PREFIX}:error`,
  LOGIN_COMPLETED: `${LOGIN_COMMANDS_PREFIX}:login-completed`,
} as const;

export type LoginCommandTypes = {
  [LoginCommands.ABORT_TRANSACTION]: never;
  [LoginCommands.RESPONSE]: never;
  [LoginCommands.ERROR]: never;
  [LoginCommands.LOGIN_COMPLETED]: (data: {
    code?: string;
    state?: string;
    error?: string;
    extId?: string;
    tabId?: string;
    appName?: string;
    error_description?: string;
    transactionId?: string;
  }) => void;
};
